<div class="container mx-auto px-5 md:px-10 lg:px-15 xl:px-[15%] mb-[53px] mt-[48px]">
    @if(this.pageData?.pageRoute != this.myAccountRoute && this.pageData?.pageName != ''){
        <div class="block lg:hidden flex items-center">
            <a class="text-[24px] text-[rgba(30,72,84,1)] " (click)="onChevronLeftClick()"><fa-icon [icon]="faChevronLeft" /></a>
            <div class="text-[30px] font-[DMSans] w-full text-center font-bold text-[rgba(30,72,84,1)] ">{{this.pageData?.pageName}}</div>
        </div>
    }@else if (this.pageData?.pageRoute == this.myAccountRoute) {
        <div class="block lg:hidden gap-[30px] min-h-[85px]  py-[16px] px-[16px]">
            <div class="flex flex-row items-center">
                <div class="flex rounded-full min-w-[81px] h-[81px] w-[81px] justify-center items-center text-center mt-[7px] text-[16px] bg-[rgba(0,106,152,1)] text-[rgba(255,255,255,1)] text-[20px]">{{ initials() }}</div>
                <div class="flex flex-col ">
                    <div class="ml-[15px] flex flex-row items-center">
                        <div class="text-[rgba(27,31,35,1)] font-[DMSans] text-[30px] font-bold">Hello</div>
                        <div class="pl-[5px] font-[DMSans] text-[rgba(0,106,152,1)] text-[30px] font-bold">{{ userName().split(" ",1) }}</div>
                    </div>
                    <div class="ml-[15px] font-[DMSans] text-[rgba(110,110,110,1)] text-[20px] font-bold">{{ email() }}</div>
                </div>
                
            </div>
        </div>
        <div class="hidden lg:hidden grid grid-cols-3 gap-[30px] min-h-[85px] bg-[rgba(25,166,223,.1)] py-[16px] px-[16px] rounded-lg">
            <div class="flex flex-col items-center">
                <div class="flex flex-row items-center">
                    <fa-icon class="text-[18px] text-[rgba(0,106,152,1)]" [icon]="faCreditCard" />
                    <div class="ml-[9px] text-[rgba(27,31,35,1)] font-bold">3</div>
                </div>
                <div class="text-center mt-[7px] text-[16px] text-[rgba(110,110,110,1)]">Purchases</div>
            </div>
            <div class="flex flex-col items-center">
                <div class="flex flex-row items-center">
                    <fa-icon class="text-[18px] text-[rgba(0,106,152,1)]" [icon]="faHand" />
                    <div class="ml-[9px] text-[rgba(27,31,35,1)] font-bold">5</div>
                </div>
                <div class="text-center mt-[7px] text-[16px] text-[rgba(110,110,110,1)]">Bid Leader</div>
            </div>
            <div class="flex flex-col items-center">
                <div class="flex flex-row items-center">
                    <fa-icon class="text-[18px] text-[rgba(0,106,152,1)]" [icon]="faComment" />
                    <div class="ml-[9px] text-[rgba(27,31,35,1)] font-bold">23</div>
                </div>
                <div class="text-center mt-[7px] text-[16px] text-[rgba(110,110,110,1)]">Referrals</div>
            </div>
        </div>
    }
    <div class="hidden lg:flex justify-between">
        <div class="w-full text-[30px] font-[DMSans] font-bold text-[rgba(30,72,84,1)] ">{{this.pageData?.pageName}}</div>
        <div class="flex justify-center" *ngIf="isCreditCardPage() && !creditCardComponentRef?.isNewCard">
            <button pButton (click)="openAddCreditCardModal()" class="!font-noto-serif w-[242px] h-9 max-w-[338px]"  >
                Add Credit Card
            </button>
        </div>
    </div>
    <app-custom-breadcrumb [separatorIsChevron]="true" [isSmall]="true" [hideOnMobile]="true"></app-custom-breadcrumb>
    <router-outlet (activate)="onActivate($event)"></router-outlet>
</div>